import { Container, Card, Button, Col, Row } from "react-bootstrap";
import { FaHistory } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import EditForm from "../components/EditForm/EditForm";
import Header from "../components/Header/Header";
import React, { useState } from "react";
import axios from "../axios";
import { useParams } from "react-router-dom";
import Pop from "../components/DealHistory/DealHistory";

const EditDealForm: React.FC = () => {
  const { dealNo } = useParams<{ dealNo: string }>();
  const [showHistory, setShowHistory] = useState(false);
  const [historyData, setHistoryData] = useState<any[]>([]);

  const fetchHistory = async () => {
    if (!dealNo) {
      console.error("No dealNo found in URL");
      return;
    }

    try {
      const response = await axios.get(`/api/deals/${dealNo}/history`);

      const history = Array.isArray(response.data) ? response.data : [];

      setHistoryData(history);
    } catch (error) {
      console.error(
        "Error fetching history:",
        error.response?.data || error.message
      );
      setHistoryData([]);
    }
  };

  const handleShowHistory = async () => {
    setShowHistory(true);
    await fetchHistory();
  };

  return (
    <div className="w-full p-4 min-h-screen flex flex-col mt-5">
      <Container className="pt-4 mx-auto w-full lg:ps-44">
        <div className="mb-6 ps-4 md:ps-8 lg:ps-16">
          <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2 mb-2 lg:text-3xl">
            <MdEdit className="text-gray-700" /> Edit Deal Management
          </h2>
          <p className="text-gray-600 text-sm md:text-base lg:text-lg">
            Modify existing deal details. Ensure accuracy before submitting your
            changes.
          </p>
        </div>
        <Card
          className="shadow-lg w-full p-3 border-2 border-gray-300"
          style={{ borderRadius: "15px", width: "107%" }}
        >
          <Card.Body>
            <div className="ms-2 mb-3 md:ms-10 lg:ms-16">
              <Header
                title="Edit DealManagement Form"
                description="Update the existing dealmanagement information below."
              />
            </div>
            <Row className="d-flex justify-content-end">
              <Col xs="auto">
                <Button
                  variant="primary"
                  className="px-4 h-10 !font-semibold absolute top-0 right-0 mt-7 me-12"
                  onClick={handleShowHistory}
                  disabled={!dealNo}
                >
                  <FaHistory className="inline-block mr-1" /> View History
                </Button>
              </Col>
            </Row>

            <hr className="text-gray-900 ms-2 mr-4" />
            <EditForm refershHistory={fetchHistory} />
          </Card.Body>
        </Card>
      </Container>
      <Pop
        show={showHistory}
        handleClose={() => setShowHistory(false)}
        historyData={historyData}
      />
    </div>
  );
};

export default EditDealForm;
